import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";

export class BetBarValueText {

    protected currencyValueText: FlexiText;
    protected creditsValueText: FlexiText;
    protected valueText: FlexiText;

    constructor(protected layer: Layers, protected name: string, protected hideNillValue = false) {

    }

    public refresh() {
        this.currencyValueText = this.layer.getFlexiText(this.name + "_currency_value");
        this.creditsValueText = this.layer.getFlexiText(this.name + "_credits_value");
        this.valueText = this.layer.getFlexiText(this.name + "_value");
    }

    public update(value: number) {
        if (this.currencyValueText) {
            if (value <= 0 && this.hideNillValue) {
                this.currencyValueText.setText("");
            } else {
                this.currencyValueText.setText(Services.currency.format(value, true, false));
            }
        }

        if (this.creditsValueText) {
            if (value <= 0 && this.hideNillValue) {
                this.creditsValueText.setText("");
            } else {
                this.creditsValueText.setText(Services.currency.format(value, true, true));
            }
        }

        if (this.valueText) {
            if (value <= 0 && this.hideNillValue) {
                this.valueText.setText("");
            } else {
                this.valueText.setText(Services.currency.format(value));
            }
        }
    }
}
